import { render } from "./eye.vue?vue&type=template&id=72400a18&ts=true"
import script from "./eye.vue?vue&type=script&lang=ts"
export * from "./eye.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__